export class ApplicationUser {
  userId: number;
  username: string;
  email: string;
  redactedEmail: string;
  password: string;
  adminAccess: boolean;
  reportsAccess: boolean;
  editLetterAccess: boolean;
  roleName: string;
  firstName: string;
  lastName: string;
  acceptedTerms: boolean;
  deviceFingerprint: string;
  ipAddress: string;
  country: string;
  region: string;
  city: string;
}
